import { useCallback } from 'react';

import MaterialsList from '@sayyesschool/frontend/components/materials-list';
import PageSection from '@sayyesschool/frontend/components/page-section';
import { useEnrollmentActions } from '@sayyesschool/frontend/features/enrollments';
import { useMaterials } from '@sayyesschool/frontend/features/materials';
import { IconButton, Menu } from '@sayyesschool/frontend/ui-components';

export default function EnrollmentMaterials({ enrollment }) {
    const [materials] = useMaterials();
    const actions = useEnrollmentActions();

    const handleAddMaterial = useCallback((event, { value }) => {
        if (!value) return;

        return actions.updateEnrollment(enrollment.id, {
            materialIds: enrollment.materialIds.concat(value)
        });
    }, [enrollment, actions]);

    const handleRemoveMaterial = useCallback(materialId => {
        return actions.updateEnrollment(enrollment.id, {
            materialIds: enrollment.materialIds.filter(id => id !== materialId)
        });
    }, [enrollment, actions]);

    if (!materials) return null;

    const enrollmentMaterials = materials
        .filter(material => enrollment.materialIds.includes(material.id));

    const items = materials
        .filter(material => !enrollment.materialIds.includes(material.id))
        .map(material => ({
            key: material.id,
            value: material.id,
            content: material.title
        }));

    return (
        <PageSection
            className="EnrollmentMaterials"
            title="Пособия"
            actions={
                <Menu
                    trigger={
                        <IconButton
                            icon="add"
                            size="sm"
                        />
                    }
                    items={items}
                    onItemClick={handleAddMaterial}
                />
            }
            compact
        >
            {enrollmentMaterials.length > 0 &&
                <MaterialsList
                    materials={enrollmentMaterials}
                    onRemove={handleRemoveMaterial}
                />
            }
        </PageSection>
    );
}